import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAdministrationTransporteurs } from 'store/administration/administrationActions';
import { fetchDepotsGestion } from 'store/depotGestion/depotGestionActions';


import { postTransporteurCompte } from 'store/administration/administrationActions';
import { deleteTransporteurCompte } from 'store/administration/administrationActions';
import { setDefautTransporteurCompte } from 'store/administration/administrationActions';


import AdministrationTransporteurComptes from './AdministrationTransporteurComptes';
import withLoader from 'components/Shared/withLoader';

const AdministrationTransporteurComptesWithLoader = withLoader(AdministrationTransporteurComptes);

class AdministrationTransporteurComptesContainer extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            addTransporteurCompteDialogOpen: false,
            deleteTransporteurCompteDialogOpen: false,
            transporteurCompteToDelete: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationTransporteurs();
        await this.props.fetchDepotsGestion();
    }

       



    handleOpenAddDialog = () => {
        this.setState({
            addTransporteurCompteDialogOpen: true
        });
    };
    handleCloseAddDialog = () => {
        this.setState({
            addTransporteurCompteDialogOpen: false
        });
    };

    addTransporteurCompte = async (transporteurCompte) => {
        await this.props.postTransporteurCompte(this.props.transporteur, transporteurCompte);
    };



    handleOpenDeleteDialog = (id) => {
        this.setState({
            deleteTransporteurCompteDialogOpen: true,
            transporteurCompteToDelete: this.props.transporteur.comptes.find(x => x.id === id)
        });
    };
    handleCloseDeleteDialog = () => {
        this.setState({
            deleteTransporteurCompteDialogOpen: false,
            transporteurCompteToDelete: null
        });
    };


    deleteTransporteurCompte = async (transporteurId, transporteurCompteId) => {
        this.setState({
            deleteTransporteurCompteDialogOpen: false
        });
        await this.props.deleteTransporteurCompte(transporteurId, transporteurCompteId);
    };



    setDefautTransporteurCompte = async (transporteurCompteId) => {
        await this.props.setDefautTransporteurCompte(this.props.transporteur.id, transporteurCompteId);
    };

    

    render() {
        
        const { isLoading, isPatching, transporteurs, transporteur, depotsGestion } = this.props;


        return (
            <AdministrationTransporteurComptesWithLoader
                isLoading={isLoading}
                isPatching={isPatching}
                transporteurs={transporteurs}
                depotsGestion={depotsGestion}

                selectedTransporteur={transporteur}


                addTransporteurCompteDialogOpen={this.state.addTransporteurCompteDialogOpen}
                addTransporteurCompte={this.addTransporteurCompte}
                onOpenAddDialog={this.handleOpenAddDialog}
                onCloseAddDialog={this.handleCloseAddDialog}


                deleteTransporteurCompteDialogOpen={this.state.deleteTransporteurCompteDialogOpen}
                deleteTransporteurCompte={this.deleteTransporteurCompte}
                onOpenDeleteDialog={this.handleOpenDeleteDialog}
                onCloseDeleteDialog={this.handleCloseDeleteDialog}
                transporteurCompteToDelete={this.state.transporteurCompteToDelete}

                setDefautTransporteurCompte={this.setDefautTransporteurCompte}
            />);
    }
}

AdministrationTransporteurComptesContainer.propTypes = {
    id: PropTypes.number
};

const mapStateToProps = (state, ownProps) => ({
    isLoading: state.administration.transporteurs.isLoading || state.depotGestion.depotsGestion.isLoading,
    isPatching: state.administration.transporteurs.isPatching,
    transporteurs: state.administration.transporteurs.items,
    transporteur: state.administration.transporteurs.items.find(x => x.id === ownProps.id),
    depotsGestion: state.depotGestion.depotsGestion.items
});



const mapDispatchToProps = {
    fetchAdministrationTransporteurs,
    fetchDepotsGestion,
    postTransporteurCompte,
    deleteTransporteurCompte,
    setDefautTransporteurCompte
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationTransporteurComptesContainer);